<app-breadcrumb
  *ngIf="repository.breadcrumbs$ | async as breadcrumbs"
  [items]="breadcrumbs"
  [backButton]="true"
></app-breadcrumb>

<app-skeleton
  *ngIf="
    !(repository.nomenclature$ | async) &&
    !(repository.nomenclatureError$ | async)
  "
></app-skeleton>

<div *ngIf="repository.nomenclatureError$ | async as nomenclatureError">
  <nz-result
    [class]="'result-status-' + nomenclatureError.status"
    [nzStatus]="nomenclatureError.status"
    [nzTitle]="nomenclatureError.status"
    [nzSubTitle]="nomenclatureError.title"
  >
    <div nz-result-extra>
      <a class="button button-primary" [routerLink]="'/' + HelixRoutes.Catalog">
        Перейти в каталог
      </a>
    </div>
  </nz-result>
</div>

<div
  *ngIf="
    !(repository.nomenclatureError$ | async) &&
    (repository.nomenclature$ | async) as nomenclature
  "
>
  <div class="section section-has-sider">
    <div class="section-content section-sider-mobile-top grid">
      <div class="section-main min-w-128">
        <app-catalog-pageheader
          [hxid]="(repository.hxid$ | async) ?? ''"
          [title]="(repository.title$ | async) ?? ''"
          [name]="(repository.simpleName$ | async) ?? ''"
          class="hidden-sm"
        ></app-catalog-pageheader>
        <div class="overflow-hidden">
          <div
            *ngIf="
              nomenclature.preorderAvailability !==
              PreorderAvailabilityStatus.Available
            "
            class="alert alert-info alert-primary mb-20"
          >
            <div class="alert-content grid grid-center">
              <div
                class="alert-message"
                [ngSwitch]="nomenclature.preorderAvailability"
              >
                <div *ngSwitchCase="PreorderAvailabilityStatus.MobileService">
                  Эту услугу можно заказать по телефону
                  <a
                    class="typography typography-bold"
                    [href]="
                      'tel:' + (storage.configuration$ | async)?.phoneNumber
                    "
                  >
                    {{ (storage.configuration$ | async)?.phoneNumber }}
                  </a>
                  или на странице заказа мобильной службы.
                </div>

                <div *ngSwitchCase="PreorderAvailabilityStatus.Appointment">
                  Для заказа услуги заполните
                  <span
                    class="typography typography-bold cursor-pointer"
                    (click)="repository.openModalAppointmentDoctor()"
                    >форму</span
                  >
                  и наш специалист свяжется с вами для подтверждения заявки. Или
                  обратитесь в Контакт-центр Хеликс по номеру
                  <a
                    class="typography typography-bold nowrap"
                    *ngIf="storage.federalPhone$ | async as federalPhone"
                    [href]="'tel:' + federalPhone"
                  >
                    {{ federalPhone }}</a
                  >.
                </div>

                <div
                  *ngSwitchCase="
                    PreorderAvailabilityStatus.OnlyInDiagnosticCenter
                  "
                >
                  {{ (isHelixLite$ | async) ? AddToCartMessages.CannotPreorderHelixLiteMessage : AddToCartMessages.CannotPreorderMessage }}
                </div>

                <div *ngSwitchCase="PreorderAvailabilityStatus.NotAvailable">
                  В настоящее время данная услуга недоступна для заказа в вашем
                  регионе.
                </div>
              </div>
            </div>
          </div>

          <!-- empty -->
          <div
            *ngIf="
              (repository.isEmptyNomenclature$ | async) &&
              nomenclature.preorderAvailability ===
                PreorderAvailabilityStatus.Available &&
              (repository.appointmentType$ | async) !==
                AppointmentServiceType.Vaccination
            "
          >
            <div class="typography typography-headline grey-800">
              Описание в разработке.
            </div>
          </div>

          <!-- not empty. ordinary and covid -->
          <nz-tabset
            *ngIf="
              !(repository.isEmptyNomenclature$ | async) &&
              (repository.appointmentType$ | async) !==
                AppointmentServiceType.Vaccination
            "
            class="tabs-nav-gray"
            (nzSelectChange)="repository.setTab($event)"
            [nzSelectedIndex]="repository.currentTabIndex$ | async"
          >
            <ng-container *ngFor="let tab of repository.tabSet$ | async">
              <ng-container [ngSwitch]="tab">
                <nz-tab
                  nzForceRender="true"
                  *ngSwitchCase="CatalogItemTab.Description"
                  [nzTitle]="tab"
                >
                  <app-catalog-item-description></app-catalog-item-description>
                </nz-tab>
                <nz-tab
                  nzForceRender="true"
                  *ngSwitchCase="CatalogItemTab.Complex"
                  [nzTitle]="tab"
                >
                  <app-complex-parts
                    [parts]="nomenclature.parts ?? []"
                  ></app-complex-parts>
                </nz-tab>
                <nz-tab
                  nzForceRender="true"
                  *ngSwitchCase="CatalogItemTab.Preparations"
                  [nzTitle]="tab"
                >
                  <app-preparations
                    [preparations]="nomenclature.patientPreparations ?? []"
                  ></app-preparations>
                </nz-tab>
                <nz-tab
                  nzForceRender="true"
                  *ngSwitchCase="CatalogItemTab.Indications"
                  [nzTitle]="tab"
                >
                  <app-indications-tab
                    [drugInfluenceGroups]="
                      nomenclature.drugInfluenceGroups ?? []
                    "
                  ></app-indications-tab>
                </nz-tab>
              </ng-container>
            </ng-container>
          </nz-tabset>
        </div>
      </div>

      <div class="section-sider section-sider-item grid-item grid-4 grid-sm-12">
        <app-catalog-pageheader
          [hxid]="(repository.hxid$ | async) ?? ''"
          [title]="(repository.title$ | async) ?? ''"
          [name]="(repository.simpleName$ | async) ?? ''"
          class="hidden block-sm"
        ></app-catalog-pageheader>

        <div class="h-48 hidden-sm"></div>

        <div class="affix affix-top-40">
          <div class="grid grid-sm-nowrap scrollable-x" #scrollElement>
            <div class="grid-item grid-12 grid">
              <app-catalog-item-price
                (scrollTo)="scrollToHelixExpressAd()"
                class="grid full-width"
              ></app-catalog-item-price>
            </div>

            <div
              class="grid-item grid-12 grid-sm-11 grid card-helix-express-ad"
              *ngIf="repository.isShowHelixExpressAd$ | async"
            >
              <app-catalog-helix-express-ad
                class="grid full-width"
              ></app-catalog-helix-express-ad>
            </div>
          </div>

          <div
            class="grid grid-nowrap mt-20"
            *ngIf="
              (repository.appointmentType$ | async) ===
              AppointmentServiceType.Default
            "
          >
            <div class="icon icon-alert-triangle icon-24"></div>
            <div class="ml-24 typography typography-body grey-300">
              Взятие биоматериала одного типа для разных анализов оплачивается
              один раз.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
